import React from "react";
import Select from "react-select";
import { ButtonGroup, Button, Icon } from "aible";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock, faEyeSlash, faCog, faChevronUp, faChevronDown } from "@fortawesome/free-solid-svg-icons";

import errorIcon from "images/tileIcons/error.svg";

import styles from "./style.module.css";

import { STEP_TYPE, WIZARD_SECTIONS } from "containers/Wizard/reducer";
import { PROJECT_MODES, PANEL_MODES } from "containers/Run/reducer";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import ProgressIndicator from "components/CreateWizard/Utils/ProgressIndicator";

import { isEnabled } from "utils/featureFlags";

export default class WizardHeader extends React.PureComponent {
  render() {
    const {
      isAdvanced,
      isEditBlueprint,
      style,
      name,
      index,
      isWizardShow,
      isCurrentStep,
      isStep,
      type,
      removeStep,
      stepLength,
      incrementStep,
      isEmptyModel,
      increasePriority,
      decreasePriority,
      options,
      updateOption,
      isNextEnabled,
      nextName,
      hasNext,
      projectId,
      history,
      isHover,
      stepNum,
      title,
      stepTotal,
      stepSize,
      id,
      tabs,
      hideTabs,
      checkIsEnabledTab,
      runCost,
      estimatedRunCost,
      isRunning,
      hasModels,
      notebookProgress,
      children,
      handleCancel,
      errors,
      isQuickRun,
      panelMode,
      updatePanelMode
    } = this.props;

    const isLocked = options && options["lock"];
    const isHidden = options && options["hide"];
    const selectedTab = options && options["selectedTab"];

    const errorOnStep = errors && errors.length && type == STEP_TYPE.ACADEMIC_SUCCESS.id; //only surfacing errors here

    return errorOnStep ? (
      <div className={styles.wizardStepHeader} style={style ? { ...style } : {}}>
        <Icon type={"times"} size={24} isRound background={"red"} />
        <div style={{ marginLeft: "10px" }}>
          AI Modeling Failed {/*I need title codes in the error metadata, which Is not being passed yet */}
        </div>
      </div>
    ) : (
      <div
        className={styles.wizardStepHeader + " " + (isStep && !isEditBlueprint ? styles.currentStepHeader : "")}
        style={style ? { ...style } : {}}
      >
        <div className={styles.wizardStepHeaderTitle}>
          <ProgressIndicator
            style={{ marginRight: "10px" }}
            stepNum={stepNum || 0}
            size={stepSize || 40}
            stepTotal={!isNaN(stepNum) && stepTotal}
          />
          {title ? (
            <div>{title}</div>
          ) : (
            <div>{name + " " + (isLocked ? "(Locked)" : "") + " " + (isHidden ? "(Hidden)" : "")}</div>
          )}
        </div>
        {tabs && !hideTabs && (type !== STEP_TYPE.SUCCESS.id || isEmptyModel !== true) && (
          <div className={styles.tabHolder} style={{ marginLeft: "20px" }}>
            <ButtonGroup>
              {Object.keys(tabs)
                .filter((key) => checkIsEnabledTab(key, tabs[key]))
                .map((s, i) => (
                  <Button
                    type="secondary"
                    key={tabs[s]}
                    active={selectedTab === tabs[s] || (selectedTab === undefined && i === 0)}
                    onClick={() => updateOption("selectedTab", tabs[s])}
                  >
                    {tabs[s]}
                  </Button>
                ))}
            </ButtonGroup>
          </div>
        )}
        <div style={{ flexGrow: 1 }} />
        {isEditBlueprint === true && isAdvanced && (
          <div className={styles.actionHolder} style={{ marginLet: "20px" }}>
            <ButtonGroup>
              <Button
                type="secondary"
                onClick={() => increasePriority(index)}
                disabled={index === 0}
                title={"Move Step Up"}
              >
                <FontAwesomeIcon icon={faChevronUp} />
              </Button>
              <Button
                type="secondary"
                onClick={() => decreasePriority(index)}
                disabled={index === stepLength - 1}
                title={"Move Step Down"}
              >
                <FontAwesomeIcon icon={faChevronDown} />
              </Button>
              <Button
                type="secondary"
                onClick={() => updateOption("lock", options ? !options["lock"] : true)}
                active={options && options["lock"] === true}
                title={"Lock User Input"}
              >
                <FontAwesomeIcon icon={faLock} />
              </Button>
              <Button
                type="secondary"
                onClick={() => updateOption("hide", options ? !options["hide"] : true)}
                active={options && options["hide"] === true}
                title={"Hide Step"}
              >
                <FontAwesomeIcon icon={faEyeSlash} />
              </Button>

              {/*
                  <Button
                    type="secondary"
                    onClick={() => updateOption("showOptions", options ? !options["showOptions"] : true)}
                    active={options && options["showOptions"] === true}
                  >
                    <FontAwesomeIcon icon={faCog} />
                  </Button>
                  */}
              <Button type="secondary" onClick={() => removeStep()}>
                {"Remove Step"}
              </Button>
            </ButtonGroup>
          </div>
        )}
        <ButtonGroup className={styles.flexButton} style={{ margin: "0px 10px" }}>
          <Button
            type="secondary"
            active={panelMode === PANEL_MODES.SELECTED_MODEL}
            onClick={() =>
              updatePanelMode(
                panelMode === PANEL_MODES.SELECTED_MODEL ? PANEL_MODES.CLOSED : PANEL_MODES.SELECTED_MODEL
              )
            }
            disabled={hasModels !== true}
          >
            {isQuickRun ? "Model Details" : "Adjust Settings"}
          </Button>
        </ButtonGroup>
        {id !== "new" && (type === STEP_TYPE.SUCCESS.id || type === STEP_TYPE.ACADEMIC_SUCCESS.id) && (
          <div className={styles.spendHolder}>
            {isRunning ? (
              <div className={styles.runningMessages}>
                {!hasModels ? <StatusMessage isComplete>{"Server Started"}</StatusMessage> : ""}
                {!hasModels ? (
                  <StatusMessage style={{ marginLeft: "15px" }} isComplete={notebookProgress >= 100}>
                    {"Notebooks Created"}
                  </StatusMessage>
                ) : (
                  ""
                )}
                <LoadingIndicator style={{ margin: "0px", transform: "scale(.5)" }} />
                <Button style={{ marginRight: "10px" }} type="secondary" onClick={handleCancel}>
                  Cancel Run
                </Button>
              </div>
            ) : (
              ""
            )}
            <div className={styles.spentMessage}>
              {runCost && !isNaN(runCost) ? "Total Spent: " : "Estimated Cost: "}
              <span className={styles.spendMessage}>
                {runCost && !isNaN(runCost)
                  ? "$" + Math.max(runCost).toFixed(2)
                  : !isNaN(estimatedRunCost)
                    ? "$" + estimatedRunCost.toFixed(2)
                    : "Calculating..."}
              </span>
            </div>
          </div>
        )}
      </div>
    );
  }
}

class StatusMessage extends React.PureComponent {
  render() {
    const { isComplete, style } = this.props;
    return (
      <div className={styles.statusMessage} style={{ ...style }}>
        <span>{this.props.children}</span>
        <div className={styles.statusCircle + (isComplete ? " " + styles.statusComplete : "")} />
      </div>
    );
  }
}
